export const initialLoginState = {
  username: "",
  password: "",
  remember: true,
  token: localStorage.getItem('token'),
  busy: false,
  userType: "",
  initializing: true,
};
